export var task_list = `
{{#tasks}}
    {{> tasks/_task_row current_tenant = ../current_tenant display_task_tags = ../display_task_tags display_task_comments = ../display_task_comments}}
{{/tasks}}
`;
